import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-auth',
  template: '<router-outlet><app-spinner></app-spinner></router-outlet>'
})
export class AuthComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}



// WEBPACK FOOTER //
// /var/lib/jenkins/jobs/nostra-mufit-info-prod/workspace/src/app/layout/auth/auth.component.ts